import wireframeLineChartMenuIcon from '../assets/icons/wireframeLineChartMenuIcon.svg';
import WireframeImage from './WireframeImage';

class WireframeLineChart extends WireframeImage {
  constructor(fabricObject) {
    fabricObject.style ||= 'lineChart';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframeLineChartMenuIcon;
  }

  static externalName(): string {
    return 'Line chart';
  }
}

export default WireframeLineChart;
